module.exports = __webpack_public_path__ + "img/Elastic Search.066bcf7d.png";